import { ICON_TYPES } from './iconTypes';

export default {
	body: {
		name: 'body',
		type: ICON_TYPES.ionicon,
		text: 'Body',
	},
	images: {
		name: 'images',
		type: ICON_TYPES.ionicon,
		text: 'Images',
	},
	imageSetNew: {
		name: 'map-marker-plus',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Add Set',
	},
	imageSet: {
		name: 'map-marker',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Image Set',
	},
};